import { memo, useState } from "react";
import { useTranslation } from 'react-i18next';
import EmptyList from "src/components/ui/GlobalComponents/EmptyList/EmptyList";
import { WordCard } from "src/components/ui/GlobalComponents/WordCard/WordCard";
import { SpecialWordListId } from "src/model/enum/enums";
import { Word } from "src/model/Word";
import styles from "./ListViewContent.module.scss";

interface ListViewContentProps {
    sortedWords: Word[];
    wordListId: string;
}

const ListViewContent = ({ sortedWords, wordListId }: ListViewContentProps) => {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState('');


    const filteredWords = sortedWords.filter((word) =>
        word.Text.toLowerCase().includes(searchTerm.toLowerCase())
    );


    if (filteredWords.length !== 0) {
        if (wordListId === SpecialWordListId.Unknown) {
            return <EmptyList image="Lexi/EmptyBox_C.png"
                description="Start learning new words." buttonUrl="/wordlists/discover?id=-1" />;
        } else if (wordListId === SpecialWordListId.ToLearn) {
            return <EmptyList image="Lexi/EmptyBox_B.png"
                description="Discover new words." buttonUrl="/wordlists/discover?id=-1" />;
        }
    }

    return (
        <div className={styles.listViewContent}>
            <div className={styles.searchContainer}>
                <input
                    type="text"
                    placeholder={t('Search')}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className={styles.searchInput}
                />
            </div>
            <div className={styles.wordList}>
                {filteredWords.map((word) => (
                    <div key={word.ID}>
                        <WordCard word={word} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default memo(ListViewContent);
